import { defineStore } from 'pinia'
import { store } from '../index'
import { getAssetGroupByProject, GetNodesByGroup } from '@/api/apm'
import { treeToList } from '@/utils'

export const useCommonStore = defineStore({
  id: 'Common',
  state: () => ({
    loginPageSetting: null as any,
    portalPageSetting: null as any,
    serviceSetting: {},
    eventColors: null,
    groups: [],
    nodes: {},
    rawNodeTree: {},
    chartColors:{
      c_txt:'',
      c_chart_label:'',
      c_chart_line:'',
      c_popper_border:'',
      c_popper_bg:'',
      c_chart_legend_label:'',
      c_chart_zoom_border:'',
      c_chart_zoom_bg:'',
      c_chart_zoom_fill:'',
      c_chart_zoom_fill_border:'',
      c_chart_zoom_cur_fill:'',  
    },
    PIUrl: null,
    iKUrl: null,
    areaUrl: null,
  }),
  getters: {
    getServiceSettings(): any {
      return this.serviceSetting
    },
    getEventColors(): any {
      return this.eventColors
    },
    getChartColors(): any {
      return this.chartColors
    },
    getPIUrl(): any {
      return this.PIUrl
    },
    getiKUrl(): any {
      return this.iKUrl
    },
    getAreaUrl(): any {
      return this.areaUrl
    },
  },
  actions: {
    async fetchGroups(payload: any) {
      const groupNames = payload.groupNames
      const projectNames = payload.projectNames
      const req:any = {
        gteGrade: 2,
        count: 1000
      }
      if (groupNames) req.groupName = groupNames
      if (projectNames) req.projectName = projectNames
      await getAssetGroupByProject(req).then(res => {
        if (!res) throw new Error('')
        if (res.errorCode) throw new Error(res.message)
        this.groups = res.e?res.e:[]
      }).catch(err => {
        console.log(err)
      })
    },
    async fetchGroupNodes(payload: any) {
      const grpName = payload
      let tree = []
      const req:any = {
        groupName: grpName,
        structType: 'hierarchy',
        withOutImage: true,
        sortType: 'ASC',
        queryGrade: true,
        gteGrade: 2
      }
      await GetNodesByGroup(req).then(res => {
        if (!res) throw new Error('')
        if (res.errorCode) throw new Error(res.message)
        // if (res[0]) tree = res[0].child
        tree = res?res:[]
      }).catch(err => {
        console.log(err)
      })
      this.rawNodeTree[grpName] = JSON.stringify(tree)
      const list:any = treeToList(tree, 'child') // treeToList会改变tree
      this.nodes[grpName] = list
    },
    async getGroups(payload: any) {
      const forceUpdate = payload.forceUpdate
      if (forceUpdate || this.groups.length === 0) {
        const req:any = {
          gteGrade: 2,
          count: 1000
        }
        if ((window as any).$wujie && (window as any).$wujie.props && (window as any).$wujie.props.dataSourceInfo) {
          const dataSourceInfo:any = (window as any).$wujie.props.dataSourceInfo
          console.log('@@@@@@@@@ $wujie.props.dataSourceInfo:', dataSourceInfo)
          if (dataSourceInfo.type === 'project') {
            if (dataSourceInfo.value && dataSourceInfo.value.length > 0) {
              req.projectNames = dataSourceInfo.value.map((item:any) => item.name)
            }
          }
          if (dataSourceInfo.type === 'group') {
            if (dataSourceInfo.value && dataSourceInfo.value.length > 0) {
              req.groupNames = dataSourceInfo.value.map((item:any) => item.name)
            }
          }
          if (req.groupNames || req.projectNames) await this.fetchGroups(req)
        } else {
          await this.fetchGroups(req)
        }
      }
      return this.groups
    },
    async getNodesByGrpName(payload: any) {
      const grpName = payload.grpName
      const forceUpdate = payload.forceUpdate
      if (forceUpdate || !this.nodes[grpName]) {
        await this.fetchGroupNodes(grpName)
      }
      return this.nodes[grpName]?this.nodes[grpName]:[]
    },
    async getRawNodeTree(payload: any) {
      const grpName = payload.grpName
      const forceUpdate = payload.forceUpdate
      if (forceUpdate || !this.rawNodeTree[grpName]) {
        await this.fetchGroupNodes(grpName)
      }
      return this.rawNodeTree[grpName]?this.rawNodeTree[grpName]:[]
    },
    setLoginPageSetting(payload: any) {
      console.log('setLoginPageSetting:', payload)
      this.loginPageSetting = payload
    },
    setPortalPageSetting(payload: any) {
      console.log('setPortalPageSetting:', payload)
      this.portalPageSetting = payload
    },
    setServiceSetting(payload: any) {
      console.log('setServiceSetting:', payload)
      this.serviceSetting[payload.service_type] = payload
    },
    delServiceSetting(payload: any) {
      console.log('delServiceSetting:', payload)
      delete this.serviceSetting[payload]
    },
    setEventColors(payload: any) {
      this.eventColors = payload
    },
    setChartColors(payload: any) {
      this.chartColors = payload
    },
    setPIUrl(payload: any) {
      this.PIUrl = payload
    },
    setiKUrl(payload: any) {
      this.iKUrl = payload
    },
    setAreaUrl(payload: any) {
      this.areaUrl = payload
    },
  }
})

export const useCommonStoreWithOut = () => {
  return useCommonStore(store)
}

export const getState = () => {
  return useCommonStore(store).$state
}
